import React from 'react';

import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch-dom';
import OverlaySearchBox from './overlay-search-box';
import OverlaySearchResult from './overlay-search-result';

export default class SearchOverlayControls extends React.Component {
  constructor(props) {
    super(props);

    this.algoliaClient = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY,
    );

    this.searchClient = {
      search(requests) {
        if (requests[0].params.query === "") {
          return [];
        }
        return this.algoliaClient.search(requests);
      },
    };

    this.searchClient.search = this.searchClient.search.bind(this);
  }

  render() {
    return (
      <>
      <InstantSearch
        searchClient={ this.searchClient }
        indexName={'PDR-combined'}
        onSearchStateChange={({ query }) => this.props.setQuery(query)}
      >
        <OverlaySearchBox
          searchOverlayFieldRef={this.props.searchOverlayFieldRef}
        />
        <div className="search-results">
          <ul>
            {(this.props.query && this.props.query.length > 0) && (
              <OverlaySearchResult
                show={ this.props.query && this.props.query.length > 0 }
                indices={[{ name: 'PDR-combined', title: 'PDR-combined' }]}
              />
            )}
          </ul>
        </div>
      </InstantSearch>
      </>
    );
  }
}
